import { Image, View } from '@react-pdf/renderer';

import { InvoiceTemplate } from '../InvoiceTemplateForm';

import styles from './Styles';

export const Logo = ({ fileUrl, template }: { fileUrl?: string; template?: InvoiceTemplate }) => (
  <>
    {fileUrl && (template?.logoLogo ?? true) && (
      <View style={styles.half_section}>
        <Image src={fileUrl} cache />
      </View>
    )}
  </>
);
